import { createApp } from "vue";
import autoRegisterComponents from "@/plugins/auto-register-components";

// Fancybox renders overlays at body level via {% html at endBody %}, outside
// the main #app mount. Each overlay therefore needs its own Vue sub-app so the
// templates inside get compiled. Mount lazily on first reveal; the WeakSet
// prevents re-mounting when the user reopens the same overlay.
const mounted = new WeakSet();

export function mountFancyboxOverlay(slide) {
    const src = slide && slide.src;
    if (typeof src !== "string" || !src.startsWith("#")) return;
    const el = document.getElementById(src.slice(1));
    if (!el || mounted.has(el)) return;
    mounted.add(el);
    createApp({}).use(autoRegisterComponents).mount(el);
}
